$(document).ready(() => {
	$("[data-match-height]").each(function () {
		$(this).find($(this).attr("data-match-height")).matchHeight();
	});
	$('body').on('click', '#header .menu-popup .toggle:not(.back)', function (){
		$("#menu_popup").toggleClass("open");
		$("body").addClass("disable_scroll");
		$("#header .menu-popup .toggle").addClass("back");
		setTimeout(() => $("#menu_popup").toggleClass("animate"), 10);
	});
	$('body').on('click', '#header .menu-popup .back,#menu_popup .back', function (){
		$("#menu_popup").removeClass("animate");
		$("body").removeClass("disable_scroll");
		$("#header .menu-popup .toggle").removeClass("back");
		setTimeout(() => $("#menu_popup").removeClass("open"), 400);
	});

	const playWhenVisible = function(item, slider){
		const Obs = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if(!entry.isIntersecting){
					slider.pause();
				}
				else {
					slider.play();
				}
			});
		}, {
			root: null,
			rootMargin: '0px',
			threshold: 0.3
		});
		Obs.observe($(item).closest('.tns-outer')[0]);
	};

	let autoplayTimeout=5000;
	if(!$('body').hasClass('home'))autoplayTimeout = 3000;

	if ($(".home-slider .slider").length) {
		const HomeSlider = tns({
			container: ".home-slider .slider",
			items: 1,
			gutter: 30,
			controlsText: ["", ""],
			nav: false,
			loop: true,
			autoplay: false,
		});
		//playWhenVisible($(".home-slider .slider")[0], HomeSlider);

		let homeSliderTimeout = null;
		const playHomeSlider = () => {
			if(homeSliderTimeout)clearTimeout(homeSliderTimeout);
			$.youTube.destroy();

			const item = $('.home-slider .slider .tns-slide-active > a');
			if(item.hasClass('video')){
				$.youTube.play(item.attr('href'), item);
			}

			let duration = item.data('duration') * 1000;
			homeSliderTimeout = setTimeout(()=>{
				homeSliderTimeout = null;
				HomeSlider.goTo('next');
			}, duration);
		};
		HomeSlider.events.on('indexChanged', playHomeSlider);
		playHomeSlider();
	}
	if ($(".booking .slider").length) {
		const BookinkSlider = tns({
			container: ".booking .slider",
			items: 1,
			gutter: 30,
			controlsText: ["", ""],
			nav: false,
			loop: true,
			autoplay: true,
			autoplayButtonOutput:false,
			autoplayHoverPause:true,
			autoplayTimeout:autoplayTimeout
		});
		playWhenVisible($(".booking .slider")[0], BookinkSlider);
	}
	$('.slider-type1 .slider').each(function(){
		const slider = tns({
		 container: this,
		 items: 1,
		 gutter: 30,
		 controlsText: ["", ""],
		 nav: false,
			loop: true,
			autoplay: true,
			autoplayButtonOutput:false,
			autoplayHoverPause:true,
			autoplayTimeout:autoplayTimeout
		});
		playWhenVisible(this, slider);
	});

	$('.only-img .slider').each(function(){
		const slider = tns({
		 container: this,
		 items: 1,
		 gutter: 30,
		 controlsText: ["", ""],
		 controlsContainer: $(this).parent().find(".my-controls")[0],
		 nav: false,
			loop: true,
			autoplay: true,
			autoplayButtonOutput:false,
			autoplayHoverPause:true,
			autoplayTimeout:autoplayTimeout
		});
		playWhenVisible(this, slider);
	});

	$('.only-img1 .slider').each(function(){
		const slider = tns({
		 container: this,
		 items: 1,
		 gutter: 30,
		 controlsText: ["", ""],
		 nav: false,
			loop: true,
			autoplay: true,
			autoplayButtonOutput:false,
			autoplayHoverPause:true,
			autoplayTimeout:autoplayTimeout
		});
		playWhenVisible(this, slider);
	});

	$(".datepicker").datepicker({autoHide: true, format: "dd/mm/yyyy"});
	$(".datepicker_dd_mm").each(function () {
		$(this).datepicker({autoHide: true, format: "dd.mm.yy"});
		//$('style#datepicker-container').remove();
		//$('<style id="datepicker-container">.datepicker-container{width:' + ($(this).outerWidth() - 1) + 'px!important;}</style>').appendTo('head');
	});

	$("body").on("click", ".open_popup", function (e) {
		e.preventDefault();
		if ($(this).attr("data-target")) {
			$($(this).attr("data-target")).openPopup();
		}
	});

	$(".dropdown .title").click(function (e) {
		const el = $(this).parent();
		if(el.hasClass('active')){
			el.removeClass('active');
			$(document).off('click.dropdown');
		}
		else {
			if($(".dropdown.active").length>0){
				$(".dropdown.active .title").trigger('click');
			}
			el.addClass('active');
			setTimeout(()=>{
				$(document).one('click.dropdown',function(){
					el.removeClass('active');
				});
			},1);

		}
	});
	$('body').on('click',".dropdown .content",function (e) {
		e.stopPropagation();
	});
	$(".dropdown .sld button").click(function (e) {
		e.stopPropagation();
		e.preventDefault();
		const input = $(this).parent().find('input');
		let v = input.val()*1;
		if($(this).hasClass('up')){
			v++;
		}
		else if(v>0){
			v--;
		}
		input.val(v);
	});

	$("body").on(
		"click",
		".popup button.close, .popup button.close_btn",
		function (e) {
			e.preventDefault();
			$(this)
				.closest(".popup")
				.closePopup();
		}
	);

	var header = $("#header");

	$('body').on('click','.e-product .btns .inp button', function (e){
		e.preventDefault();
		const t = $(this).val();
		const input = $('.e-product .btns .inp input');
		let v = input.val() * 1;
		if(t === "-" && v>1)v--;
		else if(t === "+")v++;
		input.val(v);
	});

	if($('.e-product .main .rs').length){
		const eProductSlider = tns({
			container: '.e-product .main .slider',
			items: 1,
			gutter: 0,
			controlsText: ["", ""],
			nav: false,
			loop: false,
			autoplay: false,
			autoplayButtonOutput:false,
		});
	}

	if($('.e-slider').length){
		const eSlider = tns({
			container: '.e-slider .slider',
			items: 1,
			gutter: 0,
			controlsText: ["", ""],
			nav: false,
			loop: true,
			autoplay: true,
			autoplayButtonOutput:false,
		});
	}

	//tabs
	$('body').on('click','.tabs[data-target] > *:not(.active)',function(e){
		e.preventDefault();
		const tab_parent =  $(this).closest('.tabs'),
			target = tab_parent.attr('data-target');
		if(tab_parent.length > 0 && target){

			const tab = $(this),
				tabs = tab_parent.find('>*'),
				index = tabs.index(tab);

			$(target).each(function(){
				const content = $(this).find('>*')
				content.removeClass('active');
				content.eq(index).addClass('active');
			});

			tabs.removeClass('active');
			tab.addClass('active');
		}
	});

	$('body').on('click', 'button.passwordVisibility', function(e){
		e.preventDefault();
		const input = $(this).parent().find('input');
		if(input.attr('type') === 'password'){
			input.attr('type', 'text');
		}
		else{
			input.attr('type', 'password');
		}
		$(this).toggleClass('view');
	});

	if($('.email-verify .otp').length){
		$('#otp-target').otpdesigner({
			typingDone: function (code) {
				$('#otp').val(code);
				console.log(code);
			},
			length: 4,
			onlyNumbers: true,
		});
	}

	if($('.track-orders-table').length){
		$('.p-sidebar a').removeClass('active');
		$('.p-sidebar a:eq(1)').addClass('active');
	}
	else if($('.p-settings').length){
		$('.p-sidebar a').removeClass('active');
		$('.p-sidebar a:eq(2)').addClass('active');
	}



	$(window).scroll(function () {
		if ($(window).scrollTop() > 10) {
			header.addClass("fixed");
		} else {
			header.removeClass("fixed");
		}
	});

	const media = window.matchMedia("(max-width: 991px)");
	mobileSupport(media);
	media.addListener(mobileSupport);
});

//popup
$.fn.openPopup = function () {
	const elem = $(this);
	if (elem.length > 0) {
		const opened_popup = $(".popup").filter(".show");

		if (opened_popup.length)
			opened_popup.closePopup();

		elem.addClass("show");
		setTimeout(() => elem.addClass("animate"), 1);
		elem.trigger("openPopup");
		elem
			.off("click.popup")
			.on("click.popup", function (e) {
					if ($(e.target).hasClass("popup"))
						elem.closePopup();
				}
			);
	}
};
$.fn.closePopup = function () {
	const elem = $(this);
	if (elem.length > 0) {
		elem.removeClass("animate");
		setTimeout(() => elem.removeClass("show"), 400);
		elem.trigger("closePopup");
	}
};

$.is_mobile = false;
const mobileSupport = (media) => {
	if (media.matches) {
		$.is_mobile = true;
		$(document).trigger("mobile_on");
		// $(".slider-type1 .btn-wrap").appendTo(".slider-type1 .slider-overlay");

		// $(".slider-type1 .btn-wrap").each(function(){
		// 	$(this).appendTo($(this).parent().find(".slider-overlay"));
		// });
	} else {
		$.is_mobile = false;
		$(document).trigger("mobile_off");
	}
};
$.youTube = {
	videoID : null,
	container : null,
	player:null,
	play: (url, container) =>{
		//url = 'https://www.youtube.com/watch?v=eM7FfoL9eGY';
		$.youTube.container = container;
		$.youTube.url = url;
		$.youTube.videoID = url.replace(/^[^v]+v.(.{11}).*/,"$1");
		if($.youTube.videoID.indexOf('http') !== -1)$.youTube.videoID = /https?:\/\/(?:[a-zA_Z]{2,3}.)?(?:youtube\.com\/watch\?)((?:[\w\d\-\_\=]+&amp;(?:amp;)?)*v(?:&lt;[A-Z]+&gt;)?=([0-9a-zA-Z\-\_]+))/i.exec(url)[2];
		$.youTube.container.addClass('disablePlayer');

		$.youTube.player = new BackgroundVideo($.youTube.videoID, container);

	},
	destroy : () => {
		if($.youTube.container === null)return;
		$.youTube.container.removeClass('disablePlayer');
		$.youTube.container.find('.bg-video').remove();
		$.youTube.videoID = null;
		$.youTube.container = null;
		$.youTube.player.deactivate();
	}
};

window.isInserted = false;
class BackgroundVideo{
	constructor(videoID, container) {
		$('<div class="bg-video"><div class="background-video-container"><div class="background-video-embed"></div></div></div>').appendTo(container);
		this.settings = {"videoID":videoID};
		this.$element = $('.background-video-container');
		this.elements = {
			"$backgroundVideoContainer" : $('.background-video-container'),
			"$backgroundVideoEmbed" : $('.background-video-embed'),
		}
		this.activate();
	}
	startVideoLoop() {
		// If the section has been removed
		if (!this.player.getIframe().contentWindow) {
			return;
		}

		this.player.seekTo(0);
	}

	prepareYTVideo(YT) {
		const $backgroundVideoContainer = this.elements.$backgroundVideoContainer;
		let startStateCode = YT.PlayerState.PLAYING; // Since version 67, Chrome doesn't fire the `PLAYING` state at start time

		if (window.chrome) {
			startStateCode = YT.PlayerState.UNSTARTED;
		}

		const playerOptions = {
			videoId: this.settings.videoID,
			events: {
				onReady: () => {
					this.player.mute();
					this.startVideoLoop();
					this.player.playVideo();
				},
				onStateChange: event => {
					switch (event.data) {
						case startStateCode:
							$backgroundVideoContainer.removeClass('elementor-invisible elementor-loading');
							break;

						case YT.PlayerState.ENDED:
							this.player.seekTo(0);
					}
				}
			},
			playerVars: {
				controls: 1,
				rel: 0,
				playsinline: 1,
			}
		}; // To handle CORS issues, when the default host is changed, the origin parameter has to be set.

		//if (elementSettings.background_privacy_mode) {
		//playerOptions.host = 'https://www.youtube-nocookie.com';
		//playerOptions.origin = window.location.hostname;
		//}

		$backgroundVideoContainer.addClass('elementor-loading elementor-invisible');
		this.player = new YT.Player(this.elements.$backgroundVideoEmbed[0], playerOptions);
	}

	activate() {
		this.apiProvider = new YoutubeLoader();

		this.apiProvider.onApiReady(apiObject => {
			this.prepareYTVideo(apiObject);
		});

	}

	deactivate() {
		if (this.player.getIframe()) {
			this.player.destroy();
		}
	}
}
class BaseLoader{
	insertAPI() {
		jQuery('script:first').before(jQuery('<script>', {
			src: this.getApiURL()
		}));
		window.isInserted = true
	}

	onApiReady(callback) {
		if (!window.isInserted) {
			this.insertAPI();
		}

		if (this.isApiLoaded()) {
			callback(this.getApiObject());
		} else {
			// If not ready check again by timeout..
			setTimeout(() => {
				this.onApiReady(callback);
			}, 350);
		}
	}
}
class YoutubeLoader extends BaseLoader{
	getApiURL() {
		return 'https://www.youtube.com/iframe_api';
	}
	isApiLoaded() {
		return window.YT && YT.loaded;
	}
	getApiObject() {
		return YT;
	}
}
